// #023: strip caller-supplied auth headers so an operation runs as the isolated wallet, not
// as whatever headers were forwarded in. HTTP header names are case-insensitive on the wire,
// so a fixed `Authorization`/`authorization` destructure let a mixed-case `AUTHORIZATION`
// survive and ride along. Drop every header whose lowercased name is authorization (plus
// proxy-authorization / cookie, which would likewise leak a caller identity into the session).
const STRIP_HEADER_NAMES = new Set(["authorization", "proxy-authorization", "cookie"]);
export function stripCallerAuthHeaders(headers) {
    if (!headers)
        return undefined;
    const rest = {};
    for (const [name, value] of Object.entries(headers)) {
        if (!STRIP_HEADER_NAMES.has(name.toLowerCase()))
            rest[name] = value;
    }
    return Object.keys(rest).length > 0 ? rest : undefined;
}
//# sourceMappingURL=sanitize-headers.js.map